import React from 'react';

export const InputGroup = () => {
  return <div>InputGroup</div>;
};
